import { DataBean } from "../DataBean";

export class Updateemployee extends DataBean {



    public async updateMonthAppliedIncapacityDistribution(idIncapacity:any,year:any,initialPaymentMonth:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateMonthAppliedIncapacityDistribution_Number_Number_Number", [idIncapacity,year,initialPaymentMonth]);
    }
}